import { useEffect, useState } from "react";
import api from "../lib/api";
import { PublicLayout, SectionHeading } from "../components/PublicLayout";
import { FAQS } from "./Help";
import { ChevronDown } from "lucide-react";

export default function PublicFAQ() {
  const [open, setOpen] = useState(null);
  const [faqs, setFaqs] = useState(FAQS);
  useEffect(() => { api.get("/site-content").then((r) => { if (r.data.faqs?.length) setFaqs(r.data.faqs); }).catch(() => {}); }, []);
  return (
    <PublicLayout>
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="public-faq-page">
        <SectionHeading eyebrow="FAQ" title="Frequently asked questions" />
        <div className="bg-white border border-neutral-200 rounded-2xl divide-y divide-neutral-100 shadow-sm">
          {faqs.map((f, i) => (
            <div key={i}>
              <button data-testid={`public-faq-q-${i}`} onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between gap-4 text-left px-6 py-4 hover:bg-neutral-50 transition-colors">
                <span className="font-medium text-neutral-900 text-sm">{f.q}</span>
                <ChevronDown size={16} className={`flex-shrink-0 text-neutral-400 transition-transform ${open === i ? "rotate-180" : ""}`} />
              </button>
              {open === i && <p className="px-6 pb-5 text-sm text-neutral-600 leading-relaxed">{f.a}</p>}
            </div>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
